import React, { forwardRef } from 'react'
import GrooveEmojiPicker from 'components/App/DesktopView/shared/EmojiPicker/Dropdown/Content/EmojiPicker'

const EmojiPicker = forwardRef((props, ref) => {
  const { onChoose } = props
  return <GrooveEmojiPicker open onSelect={onChoose} ref={ref} />
})

export default EmojiPicker
